import { render, staticRenderFns } from "./MobilesliderComponent.vue?vue&type=template&id=54db3370&"
import script from "./MobilesliderComponent.vue?vue&type=script&lang=js&"
export * from "./MobilesliderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports